import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=7a91c1a5&scoped=true&"
import script from "./Insights.vue?vue&type=script&lang=js&"
export * from "./Insights.vue?vue&type=script&lang=js&"
import style0 from "./Insights.scss?vue&type=style&index=0&id=7a91c1a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a91c1a5",
  null
  
)

export default component.exports